import React from "react";
import Footer from "./Footer";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import Header from "./Header";

function Shop() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="shop main">
      <Header />

      <main className="shop-content">
        <div className="shop-header">
          <h2 className="shop-title">New Arrivals</h2>
         
        </div>

        <div className="shop-grid">
          {productData.map((p) => (
            <div key={p.id} className="shop-card">
              <Link
                to={`/shopDetails/${p.id}`}
                onClick={toTop}
                className="shop-image-link"
              >
                <div className="shop-image-wrap">
                  <img src={p.images?.[0] || p.image} alt={p.name} />
                </div>
              </Link>
              <div className="shop-meta">
                <div className="shop-name">{p.name}</div>
                <div className="shop-price">€{Number(p.price).toLocaleString("en-US")}</div>
              </div>
            </div>
          ))}
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Shop;
